import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { SelectOption } from 'shared-types';

import { Search as SearchIcon } from '@styled-icons/bootstrap/Search';
import SelectField from '@common/components/FormElements/BlockSelectField';

import {
  CategoryPickerWrapper,
  LandingPageCategoryPicker,
  SearchButton,
} from './FulfilablesLandingPagePicker.styles';
import { some } from '@utils/some';

export const FulfilablesLandingPagePicker = ({
  categories,
  initialSelectedCategory,
}: FulfilablesLandingPagePickerProps) => {
  const router = useRouter();
  const [currentSelectedCategory, setSelectedCategory] = useState<SelectOption | null>(null);

  useEffect(() => {
    setSelectedCategory(initialSelectedCategory);
  }, [initialSelectedCategory]);

  const handleCategoryChange = (category: SelectOption) => {
    setSelectedCategory(category);
  };

  const handleApplyCategoryFilter = () => {
    if (currentSelectedCategory?.value) {
      router.push({
        pathname: router.pathname,
        query: { category: currentSelectedCategory.value },
      });
    } else {
      router.push({
        pathname: router.pathname,
        query: null,
      });
    }
  };

  const disabledPicker = !some(categories);

  const renamedAllCategories = (categories: FulfilablesLandingPagePickerProps['categories']) => {
    return (categories || []).map((category) => ({
      label: category.label === 'All' ? 'All categories' : category.label,
      value: category.value,
    }));
  };

  return (
    <LandingPageCategoryPicker>
      <CategoryPickerWrapper>
        <SelectField
          isDisabled={disabledPicker}
          value={currentSelectedCategory || undefined}
          options={renamedAllCategories(categories) || []}
          onChange={handleCategoryChange}
          label="I'm looking for..."
          className="categoryPickerField"
          fieldContainerClassName="landingPageFieldContainer"
          placeholder="All categories"
        />
      </CategoryPickerWrapper>

      <SearchButton onClick={handleApplyCategoryFilter} disabled={disabledPicker}>
        <SearchIcon width={22} height={22} />
      </SearchButton>
    </LandingPageCategoryPicker>
  );
};

type FulfilablesLandingPagePickerProps = {
  categories: SelectOption[] | undefined;
  initialSelectedCategory: SelectOption | null;
};
